import { Component } from '@angular/core';

@Component({
  selector: 'app-message-four',
  templateUrl: './message-four.component.html',
  styleUrls: ['./message-four.component.scss']
})
export class MessageFourComponent {

}
